// ResponsiveModal.jsx - レスポンシブモーダルコンテナ

import React from 'react';
import PropTypes from 'prop-types';

/**
 * レスポンシブモーダルコンテナコンポーネント
 * QuizSectionのモーダル表示をモバイル最適化
 */
const ResponsiveModal = ({ 
  children, 
  className = '',
  variant = 'standard',  // 'standard' | 'overview' | 'fullscreen'
  enableResponsive = true,
  onBackgroundClick = null  // 背景クリック時の処理
}) => {
  
  if (!enableResponsive) {
    // 既存のモーダルレイアウトを完全に保持
          // z-50に戻してモーダルを最上位に配置
      return (
        <div className="fixed inset-0 flex items-center justify-center z-50">
        <div 
          className="fixed inset-0 bg-black opacity-50" 
          aria-label="モーダル背景"
          onClick={onBackgroundClick}
        />
        <div className={`relative bg-white rounded-lg shadow-lg max-w-3xl w-full m-4 max-h-[90vh] overflow-y-auto ${className}`}>
          {children}
        </div>
      </div>
    );
  }

  // レスポンシブ改善版
  const getContainerClasses = () => {
    const baseClasses = 'relative bg-white shadow-lg overflow-y-auto';
    
    switch (variant) {
      case 'overview':
        return `${baseClasses} rounded-lg 
          max-w-3xl lg:max-w-4xl w-full 
          mx-2 sm:mx-4 my-2 sm:my-4 
          max-h-[95vh] sm:max-h-[90vh]`;
      case 'fullscreen':
        return `${baseClasses} 
          w-full h-full sm:rounded-lg sm:max-w-5xl sm:w-full 
          sm:mx-4 sm:my-4 sm:max-h-[95vh]`;
      case 'standard':
      default:
        return `${baseClasses} rounded-lg 
          max-w-2xl lg:max-w-3xl w-full 
          mx-2 sm:mx-4 my-2 sm:my-4 
          max-h-[95vh] sm:max-h-[90vh]`;
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div 
        className="fixed inset-0 bg-black bg-opacity-50" 
        aria-label="モーダル背景"
        onClick={onBackgroundClick}
      />
      <div className={`${getContainerClasses()} ${className}`}>
        {children}
      </div>
    </div>
  );
};

ResponsiveModal.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['standard', 'overview', 'fullscreen']),
  enableResponsive: PropTypes.bool,
  onBackgroundClick: PropTypes.func
};

export default ResponsiveModal; 